import { aludraApi } from 'Api/axios'

const mdl11 = {
  salesRelatedDocuments: '/mdl11/salesRelatedDocuments/Post',
  searchSalesDocuments: '/mdl11/SearchSalesDocuments/Post',
  searchSalesDocumentDetail: '/mdl11/SearchSalesDocumentDetail',
  salesAgentsUrl: '/mdl11/salesAgent/search',
  pdfURL: '/mdl11/GeneratePDF',
  emailURL: '/mdl11/ForwardEmailSalesDocuments/Post',
  ReasonCancellation: '/mdl11/ReasonCancellation',
  cannalURL: 'mdl11/getInputChannels/',
  addCotizationURL: 'mdl11/AddUpdateSalesDocuments/Post',
  getApprovallSalesOrder: 'mdl11/GetApprovalSalesOrder',
  updateApprovalSalesOrder: 'mdl11/UpdateApprovalSalesOrder',
  documentHistory: 'mdl11/documentHistory/post',
  getOdcDocument: 'mdl11/documentHistory',
  updateDocumentStatus: 'mdl11/updateDocumentStatus',
  searchQuotes: 'alucore-mdl11/api/quotes/search',
  searchSalesOrders: 'alucore-mdl11/api/sales-orders/search',
  searchDispatches: 'alucore-mdl11/api/dispatches/search',
}
const mdl12 = {
  uploadFileURL: '/mdl12/UploadFile',
}

export const UpdateApprovalSalesOrder = async payload => {
  return aludraApi.post(mdl11.updateApprovalSalesOrder, payload)
}

export const GetApprovalSalesOrder = async DocumentHeaderId => {
  return aludraApi.get(mdl11.getApprovallSalesOrder + `?Id=${DocumentHeaderId}`)
}
export const searchSalesDocumentsService = async (
  payload,
  isSearchSaleOrderWeb
) => {
  return aludraApi.post(mdl11.searchSalesDocuments, payload)
}

export const salesRelatedDocumentsService = async payload => {
  return aludraApi.post(mdl11.salesRelatedDocuments, payload)
}
export const updateDocumentStatusService = async payload => {
  return aludraApi.post(mdl11.updateDocumentStatus, payload)
}

export const AddUpdateSalesDocumentsService = async payload => {
  return aludraApi.post(mdl11.addCotizationURL, payload)
}

export const getPdfCotizacionService = async payload => {
  return aludraApi.post(mdl11.pdfURL, payload)
}

export const sendEmailCotizacionService = async payload => {
  return aludraApi.post(mdl11.emailURL, payload)
}

export const getSalesAgentsService = async payload => {
  return aludraApi.post(mdl11.salesAgentsUrl, payload)
}

export const searchSalesDocumentDetailService = async payload => {
  return aludraApi.post(mdl11.searchSalesDocumentDetail, payload)
}

export const getReasonCancellationService = async () => {
  return aludraApi.get(mdl11.ReasonCancellation)
}

export const getChannelsService = async => {
  return aludraApi.get(mdl11.cannalURL)
}

export const uploadFileService = async (
  payload,
  { onProgress, ...config } = {}
) => {
  return aludraApi.post(mdl12.uploadFileURL, payload, {
    ...config,
    onUploadProgress: ({ loaded, total }) => {
      if (!onProgress || !total) return

      onProgress(Math.round((loaded * 100) / total))
    },
  })
}

export const uploadDocumentHistory = async payload => {
  return aludraApi.post(mdl11.documentHistory, payload)
}
export const getOdcDocument = async ({ documentTypeId, documentId }) => {
  return aludraApi.get(
    mdl11.getOdcDocument +
      `?documentTypeId=${documentTypeId}&documentId=${documentId}`
  )
}

export const searchQuotes = async payload => {
  return aludraApi.post(mdl11.searchQuotes, payload)
}

export const searchSalesOrders = async payload => {
  return aludraApi.post(mdl11.searchSalesOrders, payload)
}

export const searchDispatches = async payload => {
  const response = await aludraApi.post(mdl11.searchDispatches, payload)
  if (response?.data?.Data?.Results) {
    response.data.Data = response.data.Data.Results
  }
  return response
}
